import React, { useEffect, useState } from "react";
import "./Register.css";
import VerifyEmailMobile from "./VerifyEmailMobile";
import FaceIdLogin from "../Login/FaceIdLogin";
import axios from "../../axios";
import LoginMpinPassWord from "../Login/LoginMpinPassWord";
import { useLocation, useSearchParams } from "react-router-dom";
import { TextField } from "@mui/material";

export default function Register({ setFooter, footer }) {
  localStorage.removeItem("hasShownPopup");
  localStorage.removeItem("hasShownPopupLibrary");
  localStorage.removeItem("hasShownPopupCalender");
  localStorage.removeItem("hasShownPopupHW");
  localStorage.removeItem("hasShownPopupPR");
  localStorage.removeItem("hasShownPopupActivity");
  localStorage.removeItem("hasShownPopupAssessment");
  localStorage.removeItem("hasShownPopupSelfAssessment");
  localStorage.removeItem("hasShownPopupSummary");
  localStorage.removeItem("hasShownPopupCommumity");
  const unique_id = localStorage.getItem("unique_id")
  const [inputValue, setInputValue] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [register, setRegister] = useState({
    verify: false,
    userValid: false,
    studentDetails: null,
  });
  const [registeredInfo, setRegisteredInfo] = useState();
  const [alertMessage, setAlertMessage] = useState();
  const [isInProgress, setIsInProgress] = useState(false);
  const [emailPhoneVerification, setEmailPhoneVerification] = useState({
    enterEmailOtp: null,
    verifiedEmail: false,
    enterMobileOtp: null,
    verifiedMobile: false,
  });
  let [searchParams, setSearchParams] = useSearchParams({
    unreg: "",
    userId: "",
    schoolCode: ""
  });

  const handleInputChange = (event) => {
    setInputValue(event.target.value.trim());
  };

  const handleSchoolCodeChange = (event) => {
    setSchoolCode(event.target.value.trim());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsInProgress(true);
    try {
      let response = await axios.post(`/studentAuth/validateUniqueId`, {
        unique_id: inputValue || unique_id,
        school_code: schoolCode,
      });
      if (response) {
        localStorage.clear()
        localStorage.setItem("schoolCode", schoolCode);
        if (response.data.status === "Registered") {
          setRegisteredInfo(response?.data?.data);
          setRegister({ userValid: true });
        } else {
          setRegister({
            ...register,
            verify: true,
            studentDetails: response?.data?.data,
          });
        }
      }
    } catch (error) {
      if (error?.response?.data?.status === "Registered") {
        setRegisteredInfo(error?.response?.data?.data);
        setRegister({ userValid: true });
      } else {
        setAlertMessage(error?.response?.data?.message);
      }
      setIsInProgress(false);
    }
    // setRegister({ userValid: true })
    setFooter({ ...footer, setIsLoggedIn: true });
    // Store setLogin value in local storage
    localStorage.setItem("setLogin", JSON.stringify(true));
  };

  const updateQueryParam = async () => {
    setIsInProgress(true);
    try {
      let response = await axios.post(`/studentAuth/validateUniqueId`, {
        unique_id: inputValue,
        school_code: schoolCode,
      });
      if (response) {
        if (response?.data?.status === "Registered") {
          setRegister({
            ...register,
            verify: true,
            studentDetails: response?.data?.data,
          });
          setSearchParams({ unreg: "true", userId: inputValue, schoolCode: schoolCode });
        } else {
          //todo maybe add a popup
          setAlertMessage("This user has not been registered yet!");
        }
      }
      setIsInProgress(false);
    } catch (error) {
      if (error?.response?.data?.status === "Registered") {
        setRegisteredInfo(error?.response?.data?.data);
      } else {
        setAlertMessage(error?.response?.data?.message);
      }
      setIsInProgress(false);
    }
  };

  return (
    <>
      {!register.verify && !register.userValid && (
        <div className="ContainerRegister h-100">
          <div className="row">
            <div className="col-md-3 p-0 bannerContainer">
              <img
                className="bannerImg"
                alt="icon"
                src="/LoginRegister/BannerImg.png"
              ></img>
            </div>
            <div className="col-md-9 RegisterDetailContainer">
              <form onSubmit={handleSubmit} autoComplete="on">
                <div className="InsideDetailCpntainer">
                  <div className="d-flex justify-content-center">
                    <img
                      className="registrationIcon"
                      src="/StudentImg/BreathSchoolLogo.svg"
                      alt="icon"
                    />
                  </div>
                  <div className="d-flex justify-content-center headerRegistration mt-3">
                    Get Started
                  </div>
                  <div className="d-flex justify-content-center mt-4">
                    {/* <input
                      value={schoolCode}
                      onChange={handleSchoolCodeChange}
                      className="registrationInput p-4"
                      placeholder="School Code"
                      name="School"
                      autoComplete="School"
                    /> */}
                    <TextField
                      id="outlined-basic"
                      label="School Code"
                      variant="outlined"
                      value={schoolCode}
                      onChange={handleSchoolCodeChange}
                      className="registrationInput"
                      name="text"
                      autoComplete="text"
                    />
                  </div>
                  <div className="d-flex justify-content-center mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Login ID"
                      variant="outlined"
                      value={inputValue}
                      onChange={handleInputChange}
                      className="registrationInput"
                      name="number"
                      autoComplete="number"
                    />
                  </div>

                  <div className="d-flex justify-content-center mt-4">
                    <button
                      disabled={!inputValue || isInProgress || !schoolCode}
                      type="submit"
                      className="RegisterBtn2"
                    >
                      Continue
                    </button>
                  </div>
                </div>
                {alertMessage && <span>{alertMessage}</span>}
                <p
                  style={{
                    position: "absolute",
                    textAlign: "center",
                    bottom: "30px",
                    transform: "translateX(-30px)",
                  }}
                >
                  To unregister the registered ID{" "}
                  <span
                    style={{
                      color: "#EE8900",
                      borderBottom: "1px solid #EE8900",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (inputValue) {
                        updateQueryParam();
                      }
                    }}
                  >
                    Click here
                  </span>{" "}
                  after entering Login ID
                </p>
              </form>
            </div>
          </div>
        </div>
      )}
      {register.verify && (
        <VerifyEmailMobile
          studentDetails={register.studentDetails}
          setEmailPhoneVerification={setEmailPhoneVerification}
          emailPhoneVerification={emailPhoneVerification}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
          register={register}
        />
      )}

      {register.userValid && (
        <LoginMpinPassWord
          studentDetails={registeredInfo}
          setRegister={setRegister}
          setEmailPhoneVerification={setEmailPhoneVerification}
          emailPhoneVerification={emailPhoneVerification}
          setIsInProgress={setIsInProgress}
          setSearchParams={setSearchParams}
        />
      )}
      {/* {register.userValid && <FaceIdLogin studentDetails={registeredInfo} />} */}
    </>
  );
}
